Namespace.create('cv.Views.Setup.Registration').TiersView = Marionette.CompositeView.extend({
  template : cv.Templates['setup/registration/tiers'],
  childViewContainer: '.tiers',
  childView: cv.Views.Setup.Registration.TierView,
  emptyView: cv.Views.Setup.Registration.TierView,

  events: {
  },

  childEvents: {
    'calculate_total' : function(childView, msg) {
      this.calculateTotal();
    },
    'reset_tiers' : function(childView, msg) {
      _.each(this.collection.models, function(model){
        model.set('quantity', 0);
      }, this);
    }
  },

  collectionEvents: {
  },

  childViewOptions: function(model, index) {
    // do some calculations based on the model
    return {
      enable_quantity : this.options.enable_quantity,
      has_registered : this.options.has_registered
    }
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    // Listen to the registration model promo code
    this.listenTo(this.options.registration_model, 'change:promo_code', function(model){
      if(model.get('promo_code') == ''){
        this.$('.discount').hide();
      }else{
        this.$('.discount').show();
      }
      this.calculateTotal();
    }, this);

    console.log('TiersView initialized');
  },

  isEmpty: function(collection){
  },

  templateHelpers: function(){
    return {
    }
  },

  calculateTotal: function(){
    var quantity = 0;
    var total = 0;
    _.each(this.collection.models, function(model){
      quantity = quantity + model.get('quantity');
      total = total + (model.get('amount') * model.get('quantity'));
    }, this);

    // Fill in the discount
    if(this.options.registration_model.get('promo_code') != ''){
      if(this.options.discount_model.get('type') == 'amount_off'){
        this.$('.discount').text('Discount applied.  ' + cv.formatMoney({
          show_sign : true,
          amount : this.options.discount_model.get('value'),
          currency_code : cv.campaign.get('currency_code'),
          decimal_places : 2
        }) + ' off the total amount.');

        total = total - this.options.discount_model.get('value');
        if(total < 0){
          total = 0;
        }
      }else{
        this.$('.discount').text('Discount applied.  ' + this.options.discount_model.get('value') + '% off the total amount.')
        total = total - (total * (this.options.discount_model.get('value')/100))
      }
    }

    // Fill in the total
    this.$('.total__amount').text('Total: ' + cv.formatMoney({
      show_sign : true,
      amount : total,
      currency_code : cv.campaign.get('currency_code'),
      decimal_places : 2
    })).hide().fadeIn();

    this.options.registration_model.set({
      quantity : quantity,
      amount : total.toFixed(2)
    });

    // Trigger event for main page (to show or hide CC form)
    this.triggerMethod('calculate_total');
  },

  onAttach: function(){
    // Set some classes
    if(this.options.enable_quantity){
      this.$('.tiers').addClass('tiers-quantities').removeClass('tiers-single');
    }else{
      this.$('.tiers').addClass('tiers-single').removeClass('tiers-quantities');
    }

    // Append the discount row
    this.$('.tiers').append(cv.Templates['setup/registration/discount']());

    // Append the initial total
    this.$('.tiers').append(cv.Templates['setup/registration/total']());

    // Calculate total
    this.calculateTotal();

    // If we are registered, then disable any clicks
    if(this.options.has_registered){
      this.$('.tiers').addClass('tiers-disabled');
    }
  }
});
